
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _403fIWrlDZ6hlE8sv7H2kh0dsdVXm0rEqrxM_45aGFvAUvs0Meta } from "/home/runner/work/studio-web-app/studio-web-app/pages/403.vue?macro=true";
import { default as _404ONRbokF7T_45dnonfvCX7kGHKv_CVh2acuA7sQ_mEspzwMeta } from "/home/runner/work/studio-web-app/studio-web-app/pages/404.vue?macro=true";
import { default as joinPxtM0073lPRTUuRzFOln8f7Gy30W_45YLaj2VDeHOW6wQMeta } from "/home/runner/work/studio-web-app/studio-web-app/pages/join.vue?macro=true";
import { default as index27z5Oe6eFxVEtJIG1fjDxLicnqlPxvKtmQpIyyHFAn0Meta } from "/home/runner/work/studio-web-app/studio-web-app/pages/index.vue?macro=true";
import { default as iframeQadBtVfDVrY3Y46dZIB0v9ndF95svFHgMfGpZnea4QwMeta } from "/home/runner/work/studio-web-app/studio-web-app/pages/iframe.vue?macro=true";
import { default as inviteaN0uDB8B38ZgBfbgzfdLUJ59eJRHLNlFk8fHhgbw8oMMeta } from "/home/runner/work/studio-web-app/studio-web-app/pages/invite.vue?macro=true";
import { default as signinZPSsBF3dUhmFaf_45p6clNjtm_emDFKBngiV8ooF6KCZYMeta } from "/home/runner/work/studio-web-app/studio-web-app/pages/signin.vue?macro=true";
import { default as iframe_45simnaabhgVggl1qulCF2FT3CZCuZfgp7ycxogdHoI2xN1AMeta } from "/home/runner/work/studio-web-app/studio-web-app/pages/iframe-sim.vue?macro=true";
import { default as launch25OLaPna6ruRNpXezprr3aGIQN_1JMw_45tEukr4EJoCEMeta } from "/home/runner/work/studio-web-app/studio-web-app/pages/lti/launch.vue?macro=true";
import { default as registermpuV5VU9A4YN2CY4y2BSihu9o7g1YHsyyFIlxCfrI2gMeta } from "/home/runner/work/studio-web-app/studio-web-app/pages/lti/register.vue?macro=true";
import { default as indexHYQmHiey5DJnGnP9RONpPGSj__45wZPi8oh6cQuv88_vkMeta } from "/home/runner/work/studio-web-app/studio-web-app/pages/system-admin/index.vue?macro=true";
import { default as usersgW_97H4A_FbjL4ovG7QDNc_QIlKavIDlcbnqG1akC6MMeta } from "/home/runner/work/studio-web-app/studio-web-app/pages/system-admin/users.vue?macro=true";
import { default as voices0L963iZSP8v2Y9Uzya3Fu5cjOMFzzMPa_45cM8Wp806jUMeta } from "/home/runner/work/studio-web-app/studio-web-app/pages/system-admin/voices.vue?macro=true";
import { default as summaryOMbdvj4y56_45MvU96TJFZGExyUwJvcBvnSGB1kVXBVkkMeta } from "/home/runner/work/studio-web-app/studio-web-app/pages/system-admin/summary.vue?macro=true";
import { default as charactersXYJbu5dYQe5wO0qUlOQ3UbadZ8rnliaw2Pt_45aDlt_454YMeta } from "/home/runner/work/studio-web-app/studio-web-app/pages/system-admin/characters.vue?macro=true";
import { default as workspaces0CMRBpzMnTN81PKf_45dc8Rb7_WVnY6sCUswCZI_45cSPscMeta } from "/home/runner/work/studio-web-app/studio-web-app/pages/system-admin/workspaces.vue?macro=true";
import { default as simulationsrXKVirQVwIfzpL4HMNosbQ1_HYT9VFwr5ZF3vQ0gV3MMeta } from "/home/runner/work/studio-web-app/studio-web-app/pages/system-admin/simulations.vue?macro=true";
import { default as organisationstTtqvrx5jEipEAsppoa9ClJMy8iSIZCoK0j_45_45AekJRcMeta } from "/home/runner/work/studio-web-app/studio-web-app/pages/system-admin/organisations.vue?macro=true";
import { default as _91userId_93YnSE_8q2cy2aKRRHegvsYFg3F_5Ghr2n_45siT3TZTtacMeta } from "/home/runner/work/studio-web-app/studio-web-app/pages/system-admin/user/[userId].vue?macro=true";
import { default as system_45adminJPlgI_mcs1wo6Vb35_45CI9xb9zu4mNiSfPtxaMahLzXIMeta } from "/home/runner/work/studio-web-app/studio-web-app/pages/system-admin.vue?macro=true";
import { default as auth_45callback3_45mi2b_458l6HbxhzRecCWwXuGOwBvnvULBY1meKgFShMMeta } from "/home/runner/work/studio-web-app/studio-web-app/pages/auth-callback.vue?macro=true";
import { default as deep_45linkAs5HohkdBedoqECeGAdsKMZp3W6Oxxf_uu_45X7w47BQcMeta } from "/home/runner/work/studio-web-app/studio-web-app/pages/lti/deep-link.vue?macro=true";
import { default as _91testId_93hDsrvwXS_YtqVg9blCGEcxcipTAqv0Z8Dn7tJc_45aEgUMeta } from "/home/runner/work/studio-web-app/studio-web-app/pages/test/[testId].vue?macro=true";
import { default as _91testId_93Y76HvjlYSK9k88e3AIcNQqMZT0L1m13cyRI43cM_2JwMeta } from "/home/runner/work/studio-web-app/studio-web-app/pages/submission/[testId].vue?macro=true";
import { default as open_45directlyeUFPFUQhd4Q2I6OHkJ1oK_45ybtLhfDCuvmAZBwd5kh_45YMeta } from "/home/runner/work/studio-web-app/studio-web-app/pages/moodle/open-directly.vue?macro=true";
import { default as indexoT710_45ZPiQH2rYsgtMbT2P9TYguyUbRSZBupLUZTVuEMeta } from "/home/runner/work/studio-web-app/studio-web-app/pages/[organizationSlug]/index.vue?macro=true";
import { default as _91simulationId_935JKBTEjTAtWWcTcb736EH3z_yWVHActJqDK4n0wKf7gMeta } from "/home/runner/work/studio-web-app/studio-web-app/pages/simulation/[simulationId].vue?macro=true";
import { default as indexL91s_1_MwWho1XlIjeANLzRQJjb_45Kr_45f3gQcStSQYRYMeta } from "/home/runner/work/studio-web-app/studio-web-app/pages/[organizationSlug]/settings/index.vue?macro=true";
import { default as usersek_YVLmS9KqW2O8pCCxUZCYNKGG5LbwHySFY6_45xbCtEMeta } from "/home/runner/work/studio-web-app/studio-web-app/pages/[organizationSlug]/settings/users.vue?macro=true";
import { default as generalVPMc46PEePu6S_btA6RtxJUGe0i99Ebl8gEzToOXcUcMeta } from "/home/runner/work/studio-web-app/studio-web-app/pages/[organizationSlug]/settings/general.vue?macro=true";
import { default as summaryrpzoAZ141TE4niaODYqtJCMOiYh_K6sVsE3hQuWL9j0Meta } from "/home/runner/work/studio-web-app/studio-web-app/pages/[organizationSlug]/settings/summary.vue?macro=true";
import { default as workspacesmxBtphGczqyBIQ0mD0BT1cDNAgDzGXIz2er_4MJ_izIMeta } from "/home/runner/work/studio-web-app/studio-web-app/pages/[organizationSlug]/settings/workspaces.vue?macro=true";
import { default as _91userId_93V871dgW1z8gRhr_45m5uklsWZZTFL2kvowFV18fiLmstwMeta } from "/home/runner/work/studio-web-app/studio-web-app/pages/[organizationSlug]/settings/user/[userId].vue?macro=true";
import { default as settingsf8Z1CKzHy8KYhFcQK7So8FxNaK1WYniWiEU05_45hVw78Meta } from "/home/runner/work/studio-web-app/studio-web-app/pages/[organizationSlug]/settings.vue?macro=true";
import { default as indexMVyrR0ELsqwqt7h6qVVUkBmamWa9vNiTsLf6QdUlJX0Meta } from "/home/runner/work/studio-web-app/studio-web-app/pages/sequence/[sequenceId]/index.vue?macro=true";
import { default as indexWMHF3ZyxG_45RUeZdAmGXSRfQrg9K_1MONf1wjKM7C_TMMeta } from "/home/runner/work/studio-web-app/studio-web-app/pages/simulation-assessment/index.vue?macro=true";
import { default as _91simulationId_93J9Oo39d0SZohFVtyNS0vsk8iuIfFkZwcD8lgCdejVUoMeta } from "/home/runner/work/studio-web-app/studio-web-app/pages/demo/simulation/[simulationId].vue?macro=true";
import { default as _91registrationId_93SyAJy7aB3yO9vyyKQmW5Qtu_ZYPE9SjcEGUdBgaHxakMeta } from "/home/runner/work/studio-web-app/studio-web-app/pages/moodle/connect/[registrationId].vue?macro=true";
import { default as tags8bol00nQw_vMlJSgSv6kOfX74AXXDGHE9BXERJECkG0Meta } from "/home/runner/work/studio-web-app/studio-web-app/pages/[organizationSlug]/[workspaceId]/tags.vue?macro=true";
import { default as indexi9_082N5PyCN904ozZK8g2AC5TVTGvg8QDWj_KPcBxEMeta } from "/home/runner/work/studio-web-app/studio-web-app/pages/[organizationSlug]/[workspaceId]/index.vue?macro=true";
import { default as indexGzvbyCJXVi7IjhOSv3C_uTcvEPzyECvL6BAwGhyhp2UMeta } from "/home/runner/work/studio-web-app/studio-web-app/pages/[organizationSlug]/[workspaceId]/settings/index.vue?macro=true";
import { default as users75LgOdArxxFzWVHGFkduxSFQyM_HKw6fFWDG7zL5W_0Meta } from "/home/runner/work/studio-web-app/studio-web-app/pages/[organizationSlug]/[workspaceId]/settings/users.vue?macro=true";
import { default as generalVUyNJ_45oTJZ_9EC0uLHyJPcexXZotVZtzlWWfGOS2EhgMeta } from "/home/runner/work/studio-web-app/studio-web-app/pages/[organizationSlug]/[workspaceId]/settings/general.vue?macro=true";
import { default as summaryhsNLeUBDhV7Wgl3IWrkObRNEw2fq14XiXwOuoAOnDyoMeta } from "/home/runner/work/studio-web-app/studio-web-app/pages/[organizationSlug]/[workspaceId]/settings/summary.vue?macro=true";
import { default as integrationspqA2jvgZXnBrbwCMt0X3cYX8V6SQFfK5xSdXj_ZHtYAMeta } from "/home/runner/work/studio-web-app/studio-web-app/pages/[organizationSlug]/[workspaceId]/settings/integrations.vue?macro=true";
import { default as _91userId_93ldvtTXw7bXbaF6x_45Xt1Ifr2Y7EAPLvRf0QKVIhq89xkMeta } from "/home/runner/work/studio-web-app/studio-web-app/pages/[organizationSlug]/[workspaceId]/settings/user/[userId].vue?macro=true";
import { default as settingsXswfsQCIBBYyH2nsYK3Hf3nllA7pZPcCQJwqJCeoHpEMeta } from "/home/runner/work/studio-web-app/studio-web-app/pages/[organizationSlug]/[workspaceId]/settings.vue?macro=true";
import { default as indexan_45WM4gHXht_HpRI0DIyZ8423guXB3ovnl4o49sYVLUMeta } from "/home/runner/work/studio-web-app/studio-web-app/pages/[organizationSlug]/[workspaceId]/saq/index.vue?macro=true";
import { default as indexsPrN9odamokjN_45jCZtn8gLZOjEePW8lkznI932apUugMeta } from "/home/runner/work/studio-web-app/studio-web-app/pages/[organizationSlug]/[workspaceId]/tests/index.vue?macro=true";
import { default as createYmsA7fnB6OVwLwR_45xAtnsAx2H3YW10TyRUMPRltqvx8Meta } from "/home/runner/work/studio-web-app/studio-web-app/pages/[organizationSlug]/[workspaceId]/tests/create.vue?macro=true";
import { default as eventDRaidgcymTRceI8UIqQ2YacWiUCXYIDQYkeb974t6LIMeta } from "/home/runner/work/studio-web-app/studio-web-app/pages/sequence/[sequenceId]/attempt/[attemptId]/event.vue?macro=true";
import { default as indexNCW8DWhl_O_NIjHZVvB87X1WKer1PYxdebp92gopgA4Meta } from "/home/runner/work/studio-web-app/studio-web-app/pages/sequence/[sequenceId]/attempt/[attemptId]/index.vue?macro=true";
import { default as indexeEOUbdEmICzY8vQ9Cxuw088Q266SbnVh7lw0G65tF_45sMeta } from "/home/runner/work/studio-web-app/studio-web-app/pages/[organizationSlug]/[workspaceId]/sequences/index.vue?macro=true";
import { default as indexEnWGV9ycHzOLpguNhKPcPOgHzQaF1un_5brtK4_452yT0Meta } from "/home/runner/work/studio-web-app/studio-web-app/pages/[organizationSlug]/[workspaceId]/characters/index.vue?macro=true";
import { default as createUziy14qyZ9Jc1JKOJlgrTXDmEr5gr8e__04TB5zDrIAMeta } from "/home/runner/work/studio-web-app/studio-web-app/pages/[organizationSlug]/[workspaceId]/sequences/create.vue?macro=true";
import { default as index1Tc3HWcKRsjDiremJLtzMwZ9EVv7xhpuxRV_45UfAm8DUMeta } from "/home/runner/work/studio-web-app/studio-web-app/pages/[organizationSlug]/[workspaceId]/assessments/index.vue?macro=true";
import { default as createUQT38LuOy1QkCHmcsRKr9q1UuUUiYplqGp3l5W1FiC4Meta } from "/home/runner/work/studio-web-app/studio-web-app/pages/[organizationSlug]/[workspaceId]/characters/create.vue?macro=true";
import { default as indexftFsQ_454mhqYF0DHzwm_8HLxjbptpzXJ09z1Upmn44dEMeta } from "/home/runner/work/studio-web-app/studio-web-app/pages/[organizationSlug]/[workspaceId]/simulations/index.vue?macro=true";
import { default as createZeHk_45FoTheDUiPWsqw0sXVbHZl1gCI3mLIGbQxmqzZ4Meta } from "/home/runner/work/studio-web-app/studio-web-app/pages/[organizationSlug]/[workspaceId]/assessments/create.vue?macro=true";
import { default as indexHPgvhAPRNkop1ROl8P7FtRQW8iAiat_45U7eFzVue4yYcMeta } from "/home/runner/work/studio-web-app/studio-web-app/pages/[organizationSlug]/[workspaceId]/environments/index.vue?macro=true";
import { default as createFIPdcplvfOKu5JemomuCIVK6LbW7sJDdoSstBQAKregMeta } from "/home/runner/work/studio-web-app/studio-web-app/pages/[organizationSlug]/[workspaceId]/simulations/create.vue?macro=true";
import { default as createpj9JuYhj38YDInzzWCJZxnhgVMfocfvA4VgA_v7mSqQMeta } from "/home/runner/work/studio-web-app/studio-web-app/pages/[organizationSlug]/[workspaceId]/environments/create.vue?macro=true";
import { default as indexu41Hi3mu4j84GSdfkE8ZGOwe_45WwGCnEam_vUiO3rbGsMeta } from "/home/runner/work/studio-web-app/studio-web-app/pages/[organizationSlug]/[workspaceId]/tests/[testId]/index.vue?macro=true";
import { default as indexIPZHFGW_45ghSQuq77mT2aVtJq3RNknxNNvFHG0y4RCEYMeta } from "/home/runner/work/studio-web-app/studio-web-app/pages/[organizationSlug]/[workspaceId]/saq/[questionId]/index.vue?macro=true";
import { default as _91characterId_936vXVwD0YDfPIMUiXnSmON7fl4E_LIOpp_4550wm0EW_45pIMeta } from "/home/runner/work/studio-web-app/studio-web-app/pages/[organizationSlug]/[workspaceId]/characters/[characterId].vue?macro=true";
import { default as _91testAttemptId_93L4_WJxQubpqAgVoVk9MwbjB3oRpVgRqxTTH90e_9EpwMeta } from "/home/runner/work/studio-web-app/studio-web-app/pages/[organizationSlug]/[workspaceId]/feedback/[testAttemptId].vue?macro=true";
import { default as _91environmentId_93Nw9s0rw816tCGmbE9MzKpT5PWNj6OXuPGD6_nCpaTQ0Meta } from "/home/runner/work/studio-web-app/studio-web-app/pages/[organizationSlug]/[workspaceId]/environments/[environmentId].vue?macro=true";
import { default as index8RIR1AVXVsBuLhAZPXlxeM5XJVBnFuBZz14u9WZEe7YMeta } from "/home/runner/work/studio-web-app/studio-web-app/pages/[organizationSlug]/[workspaceId]/sequences/[sequenceId]/index.vue?macro=true";
import { default as indexvyxOekgU4JQgzPvpn_45yxEC0ovjKJT_I99P6xw3miarsMeta } from "/home/runner/work/studio-web-app/studio-web-app/pages/[organizationSlug]/[workspaceId]/assessments/[assessmentId]/index.vue?macro=true";
import { default as indexrosr5euiFmu_45QeZkxVWO6oTkJYDpuRPoTPAiMAeLIoEMeta } from "/home/runner/work/studio-web-app/studio-web-app/pages/[organizationSlug]/[workspaceId]/simulations/[simulationId]/index.vue?macro=true";
import { default as indexQzpq1cbABoJN9yTC_uuOK4pspW_fsMsoQNhTh4tkT7EMeta } from "/home/runner/work/studio-web-app/studio-web-app/pages/[organizationSlug]/[workspaceId]/tests/[testId]/submissions/index.vue?macro=true";
import { default as indexwSkpEEzYiqTjwlhSzhNP6rVEJDLnnZvNF99o9KPFXdYMeta } from "/home/runner/work/studio-web-app/studio-web-app/pages/[organizationSlug]/[workspaceId]/saq/[questionId]/submissions/index.vue?macro=true";
import { default as previewuz5uXkKNLkucZov0IcKF33XCPUmUUMRoWRw7EUT2ZP4Meta } from "/home/runner/work/studio-web-app/studio-web-app/pages/[organizationSlug]/[workspaceId]/simulations/[simulationId]/preview.vue?macro=true";
import { default as indexQu5yyTdjMNcLrpw0lpuhWCeGWnFUPaNYn4VsuG9Ubd8Meta } from "/home/runner/work/studio-web-app/studio-web-app/pages/[organizationSlug]/[workspaceId]/sequences/[sequenceId]/submissions/index.vue?macro=true";
import { default as _91submissionId_93GNF1y1BT0qASfyf5CyktxhquYP1p3uuWjCA68yASkNEMeta } from "/home/runner/work/studio-web-app/studio-web-app/pages/[organizationSlug]/[workspaceId]/saq/[questionId]/submissions/[submissionId].vue?macro=true";
import { default as indexjMscKjD7X4lBB9zPzbREmm1i1bHccP0vjtP6hd8FL0wMeta } from "/home/runner/work/studio-web-app/studio-web-app/pages/[organizationSlug]/[workspaceId]/assessments/[assessmentId]/submissions/index.vue?macro=true";
import { default as indexwbvBJJJ_45rfxML0FxvT48xrptw4keoINRBTaWzg8KoC4Meta } from "/home/runner/work/studio-web-app/studio-web-app/pages/[organizationSlug]/[workspaceId]/simulations/[simulationId]/interactions/index.vue?macro=true";
import { default as _91testSubmissionId_93CJSm7399CvdLg3z2taGDLwDq2C7O0hiMoVdHgnSwfpsMeta } from "/home/runner/work/studio-web-app/studio-web-app/pages/[organizationSlug]/[workspaceId]/tests/[testId]/submissions/[testSubmissionId].vue?macro=true";
import { default as _91submissionId_93_L7hD51kerh9G2VfpO2NbzU42Zd1NQcPthiOuahmcuUMeta } from "/home/runner/work/studio-web-app/studio-web-app/pages/[organizationSlug]/[workspaceId]/sequences/[sequenceId]/submissions/[submissionId].vue?macro=true";
import { default as _91interactionId_93o6GvAd6zHy6EAUDKht6VViCyluGhOgBWZ7PZgK63j1YMeta } from "/home/runner/work/studio-web-app/studio-web-app/pages/[organizationSlug]/[workspaceId]/simulations/[simulationId]/interactions/[interactionId].vue?macro=true";
import { default as _91assessmentSubmissionId_93AoMIhdW9KwmscKFiwFe01RbLkXDzsXIwW4E_THeMdmMMeta } from "/home/runner/work/studio-web-app/studio-web-app/pages/[organizationSlug]/[workspaceId]/assessments/[assessmentId]/submissions/[assessmentSubmissionId].vue?macro=true";
export default [
  {
    name: "403",
    path: "/403",
    meta: _403fIWrlDZ6hlE8sv7H2kh0dsdVXm0rEqrxM_45aGFvAUvs0Meta || {},
    component: () => import("/home/runner/work/studio-web-app/studio-web-app/pages/403.vue")
  },
  {
    name: "404",
    path: "/404",
    meta: _404ONRbokF7T_45dnonfvCX7kGHKv_CVh2acuA7sQ_mEspzwMeta || {},
    component: () => import("/home/runner/work/studio-web-app/studio-web-app/pages/404.vue")
  },
  {
    name: "join",
    path: "/join",
    meta: joinPxtM0073lPRTUuRzFOln8f7Gy30W_45YLaj2VDeHOW6wQMeta || {},
    component: () => import("/home/runner/work/studio-web-app/studio-web-app/pages/join.vue")
  },
  {
    name: "index",
    path: "/",
    meta: index27z5Oe6eFxVEtJIG1fjDxLicnqlPxvKtmQpIyyHFAn0Meta || {},
    component: () => import("/home/runner/work/studio-web-app/studio-web-app/pages/index.vue")
  },
  {
    name: "iframe",
    path: "/iframe",
    meta: iframeQadBtVfDVrY3Y46dZIB0v9ndF95svFHgMfGpZnea4QwMeta || {},
    component: () => import("/home/runner/work/studio-web-app/studio-web-app/pages/iframe.vue")
  },
  {
    name: "invite",
    path: "/invite",
    meta: inviteaN0uDB8B38ZgBfbgzfdLUJ59eJRHLNlFk8fHhgbw8oMMeta || {},
    component: () => import("/home/runner/work/studio-web-app/studio-web-app/pages/invite.vue")
  },
  {
    name: "signin",
    path: "/signin",
    meta: signinZPSsBF3dUhmFaf_45p6clNjtm_emDFKBngiV8ooF6KCZYMeta || {},
    component: () => import("/home/runner/work/studio-web-app/studio-web-app/pages/signin.vue")
  },
  {
    name: "iframe-sim",
    path: "/iframe-sim",
    meta: iframe_45simnaabhgVggl1qulCF2FT3CZCuZfgp7ycxogdHoI2xN1AMeta || {},
    component: () => import("/home/runner/work/studio-web-app/studio-web-app/pages/iframe-sim.vue")
  },
  {
    name: "lti-launch",
    path: "/lti/launch",
    meta: launch25OLaPna6ruRNpXezprr3aGIQN_1JMw_45tEukr4EJoCEMeta || {},
    component: () => import("/home/runner/work/studio-web-app/studio-web-app/pages/lti/launch.vue")
  },
  {
    name: "lti-register",
    path: "/lti/register",
    meta: registermpuV5VU9A4YN2CY4y2BSihu9o7g1YHsyyFIlxCfrI2gMeta || {},
    component: () => import("/home/runner/work/studio-web-app/studio-web-app/pages/lti/register.vue")
  },
  {
    name: system_45adminJPlgI_mcs1wo6Vb35_45CI9xb9zu4mNiSfPtxaMahLzXIMeta?.name,
    path: "/system-admin",
    meta: { ...(system_45adminJPlgI_mcs1wo6Vb35_45CI9xb9zu4mNiSfPtxaMahLzXIMeta || {}), ...{"middleware":"require-super-admin"} },
    component: () => import("/home/runner/work/studio-web-app/studio-web-app/pages/system-admin.vue"),
    children: [
  {
    name: "system-admin",
    path: "",
    meta: indexHYQmHiey5DJnGnP9RONpPGSj__45wZPi8oh6cQuv88_vkMeta || {},
    redirect: {"name":"system-admin-summary"},
    component: () => import("/home/runner/work/studio-web-app/studio-web-app/pages/system-admin/index.vue")
  },
  {
    name: "system-admin-users",
    path: "users",
    component: () => import("/home/runner/work/studio-web-app/studio-web-app/pages/system-admin/users.vue")
  },
  {
    name: "system-admin-voices",
    path: "voices",
    component: () => import("/home/runner/work/studio-web-app/studio-web-app/pages/system-admin/voices.vue")
  },
  {
    name: "system-admin-summary",
    path: "summary",
    component: () => import("/home/runner/work/studio-web-app/studio-web-app/pages/system-admin/summary.vue")
  },
  {
    name: "system-admin-characters",
    path: "characters",
    component: () => import("/home/runner/work/studio-web-app/studio-web-app/pages/system-admin/characters.vue")
  },
  {
    name: "system-admin-workspaces",
    path: "workspaces",
    component: () => import("/home/runner/work/studio-web-app/studio-web-app/pages/system-admin/workspaces.vue")
  },
  {
    name: "system-admin-simulations",
    path: "simulations",
    component: () => import("/home/runner/work/studio-web-app/studio-web-app/pages/system-admin/simulations.vue")
  },
  {
    name: "system-admin-organisations",
    path: "organisations",
    component: () => import("/home/runner/work/studio-web-app/studio-web-app/pages/system-admin/organisations.vue")
  },
  {
    name: "system-admin-user-userId",
    path: "user/:userId()",
    component: () => import("/home/runner/work/studio-web-app/studio-web-app/pages/system-admin/user/[userId].vue")
  }
]
  },
  {
    name: "auth-callback",
    path: "/auth-callback",
    meta: auth_45callback3_45mi2b_458l6HbxhzRecCWwXuGOwBvnvULBY1meKgFShMMeta || {},
    component: () => import("/home/runner/work/studio-web-app/studio-web-app/pages/auth-callback.vue")
  },
  {
    name: "lti-deep-link",
    path: "/lti/deep-link",
    meta: deep_45linkAs5HohkdBedoqECeGAdsKMZp3W6Oxxf_uu_45X7w47BQcMeta || {},
    component: () => import("/home/runner/work/studio-web-app/studio-web-app/pages/lti/deep-link.vue")
  },
  {
    name: "test-testId",
    path: "/test/:testId()",
    meta: _91testId_93hDsrvwXS_YtqVg9blCGEcxcipTAqv0Z8Dn7tJc_45aEgUMeta || {},
    component: () => import("/home/runner/work/studio-web-app/studio-web-app/pages/test/[testId].vue")
  },
  {
    name: "submission-testId",
    path: "/submission/:testId()",
    meta: _91testId_93Y76HvjlYSK9k88e3AIcNQqMZT0L1m13cyRI43cM_2JwMeta || {},
    component: () => import("/home/runner/work/studio-web-app/studio-web-app/pages/submission/[testId].vue")
  },
  {
    name: "moodle-open-directly",
    path: "/moodle/open-directly",
    meta: open_45directlyeUFPFUQhd4Q2I6OHkJ1oK_45ybtLhfDCuvmAZBwd5kh_45YMeta || {},
    component: () => import("/home/runner/work/studio-web-app/studio-web-app/pages/moodle/open-directly.vue")
  },
  {
    name: "organizationSlug",
    path: "/:organizationSlug()",
    meta: indexoT710_45ZPiQH2rYsgtMbT2P9TYguyUbRSZBupLUZTVuEMeta || {},
    redirect: indexoT710_45ZPiQH2rYsgtMbT2P9TYguyUbRSZBupLUZTVuEMeta?.redirect,
    component: () => import("/home/runner/work/studio-web-app/studio-web-app/pages/[organizationSlug]/index.vue")
  },
  {
    name: "simulation-simulationId",
    path: "/simulation/:simulationId()",
    meta: _91simulationId_935JKBTEjTAtWWcTcb736EH3z_yWVHActJqDK4n0wKf7gMeta || {},
    component: () => import("/home/runner/work/studio-web-app/studio-web-app/pages/simulation/[simulationId].vue")
  },
  {
    name: settingsf8Z1CKzHy8KYhFcQK7So8FxNaK1WYniWiEU05_45hVw78Meta?.name,
    path: "/:organizationSlug()/settings",
    meta: settingsf8Z1CKzHy8KYhFcQK7So8FxNaK1WYniWiEU05_45hVw78Meta || {},
    component: () => import("/home/runner/work/studio-web-app/studio-web-app/pages/[organizationSlug]/settings.vue"),
    children: [
  {
    name: "organizationSlug-settings",
    path: "",
    meta: indexL91s_1_MwWho1XlIjeANLzRQJjb_45Kr_45f3gQcStSQYRYMeta || {},
    redirect: indexL91s_1_MwWho1XlIjeANLzRQJjb_45Kr_45f3gQcStSQYRYMeta?.redirect,
    component: () => import("/home/runner/work/studio-web-app/studio-web-app/pages/[organizationSlug]/settings/index.vue")
  },
  {
    name: "organizationSlug-settings-users",
    path: "users",
    meta: usersek_YVLmS9KqW2O8pCCxUZCYNKGG5LbwHySFY6_45xbCtEMeta || {},
    component: () => import("/home/runner/work/studio-web-app/studio-web-app/pages/[organizationSlug]/settings/users.vue")
  },
  {
    name: "organizationSlug-settings-general",
    path: "general",
    meta: generalVPMc46PEePu6S_btA6RtxJUGe0i99Ebl8gEzToOXcUcMeta || {},
    component: () => import("/home/runner/work/studio-web-app/studio-web-app/pages/[organizationSlug]/settings/general.vue")
  },
  {
    name: "organizationSlug-settings-summary",
    path: "summary",
    meta: summaryrpzoAZ141TE4niaODYqtJCMOiYh_K6sVsE3hQuWL9j0Meta || {},
    component: () => import("/home/runner/work/studio-web-app/studio-web-app/pages/[organizationSlug]/settings/summary.vue")
  },
  {
    name: "organizationSlug-settings-workspaces",
    path: "workspaces",
    meta: workspacesmxBtphGczqyBIQ0mD0BT1cDNAgDzGXIz2er_4MJ_izIMeta || {},
    component: () => import("/home/runner/work/studio-web-app/studio-web-app/pages/[organizationSlug]/settings/workspaces.vue")
  },
  {
    name: "organizationSlug-settings-user-userId",
    path: "user/:userId()",
    meta: _91userId_93V871dgW1z8gRhr_45m5uklsWZZTFL2kvowFV18fiLmstwMeta || {},
    component: () => import("/home/runner/work/studio-web-app/studio-web-app/pages/[organizationSlug]/settings/user/[userId].vue")
  }
]
  },
  {
    name: "sequence-sequenceId",
    path: "/sequence/:sequenceId()",
    meta: indexMVyrR0ELsqwqt7h6qVVUkBmamWa9vNiTsLf6QdUlJX0Meta || {},
    component: () => import("/home/runner/work/studio-web-app/studio-web-app/pages/sequence/[sequenceId]/index.vue")
  },
  {
    name: "simulation-assessment",
    path: "/simulation-assessment",
    meta: indexWMHF3ZyxG_45RUeZdAmGXSRfQrg9K_1MONf1wjKM7C_TMMeta || {},
    component: () => import("/home/runner/work/studio-web-app/studio-web-app/pages/simulation-assessment/index.vue")
  },
  {
    name: "demo-simulation-simulationId",
    path: "/demo/simulation/:simulationId()",
    meta: _91simulationId_93J9Oo39d0SZohFVtyNS0vsk8iuIfFkZwcD8lgCdejVUoMeta || {},
    component: () => import("/home/runner/work/studio-web-app/studio-web-app/pages/demo/simulation/[simulationId].vue")
  },
  {
    name: "moodle-connect-registrationId",
    path: "/moodle/connect/:registrationId()",
    meta: { ...(_91registrationId_93SyAJy7aB3yO9vyyKQmW5Qtu_ZYPE9SjcEGUdBgaHxakMeta || {}), ...{"middleware":["require-top-window"]} },
    component: () => import("/home/runner/work/studio-web-app/studio-web-app/pages/moodle/connect/[registrationId].vue")
  },
  {
    name: "organizationSlug-workspaceId-tags",
    path: "/:organizationSlug()/:workspaceId()/tags",
    component: () => import("/home/runner/work/studio-web-app/studio-web-app/pages/[organizationSlug]/[workspaceId]/tags.vue")
  },
  {
    name: "organizationSlug-workspaceId",
    path: "/:organizationSlug()/:workspaceId()",
    component: () => import("/home/runner/work/studio-web-app/studio-web-app/pages/[organizationSlug]/[workspaceId]/index.vue")
  },
  {
    name: settingsXswfsQCIBBYyH2nsYK3Hf3nllA7pZPcCQJwqJCeoHpEMeta?.name,
    path: "/:organizationSlug()/:workspaceId()/settings",
    meta: settingsXswfsQCIBBYyH2nsYK3Hf3nllA7pZPcCQJwqJCeoHpEMeta || {},
    component: () => import("/home/runner/work/studio-web-app/studio-web-app/pages/[organizationSlug]/[workspaceId]/settings.vue"),
    children: [
  {
    name: "organizationSlug-workspaceId-settings",
    path: "",
    meta: indexGzvbyCJXVi7IjhOSv3C_uTcvEPzyECvL6BAwGhyhp2UMeta || {},
    redirect: indexGzvbyCJXVi7IjhOSv3C_uTcvEPzyECvL6BAwGhyhp2UMeta?.redirect,
    component: () => import("/home/runner/work/studio-web-app/studio-web-app/pages/[organizationSlug]/[workspaceId]/settings/index.vue")
  },
  {
    name: "organizationSlug-workspaceId-settings-users",
    path: "users",
    component: () => import("/home/runner/work/studio-web-app/studio-web-app/pages/[organizationSlug]/[workspaceId]/settings/users.vue")
  },
  {
    name: "organizationSlug-workspaceId-settings-general",
    path: "general",
    component: () => import("/home/runner/work/studio-web-app/studio-web-app/pages/[organizationSlug]/[workspaceId]/settings/general.vue")
  },
  {
    name: "organizationSlug-workspaceId-settings-summary",
    path: "summary",
    component: () => import("/home/runner/work/studio-web-app/studio-web-app/pages/[organizationSlug]/[workspaceId]/settings/summary.vue")
  },
  {
    name: "organizationSlug-workspaceId-settings-integrations",
    path: "integrations",
    component: () => import("/home/runner/work/studio-web-app/studio-web-app/pages/[organizationSlug]/[workspaceId]/settings/integrations.vue")
  },
  {
    name: "organizationSlug-workspaceId-settings-user-userId",
    path: "user/:userId()",
    meta: _91userId_93ldvtTXw7bXbaF6x_45Xt1Ifr2Y7EAPLvRf0QKVIhq89xkMeta || {},
    component: () => import("/home/runner/work/studio-web-app/studio-web-app/pages/[organizationSlug]/[workspaceId]/settings/user/[userId].vue")
  }
]
  },
  {
    name: "organizationSlug-workspaceId-saq",
    path: "/:organizationSlug()/:workspaceId()/saq",
    component: () => import("/home/runner/work/studio-web-app/studio-web-app/pages/[organizationSlug]/[workspaceId]/saq/index.vue")
  },
  {
    name: "organizationSlug-workspaceId-tests",
    path: "/:organizationSlug()/:workspaceId()/tests",
    component: () => import("/home/runner/work/studio-web-app/studio-web-app/pages/[organizationSlug]/[workspaceId]/tests/index.vue")
  },
  {
    name: "organizationSlug-workspaceId-tests-create",
    path: "/:organizationSlug()/:workspaceId()/tests/create",
    component: () => import("/home/runner/work/studio-web-app/studio-web-app/pages/[organizationSlug]/[workspaceId]/tests/create.vue")
  },
  {
    name: "sequence-sequenceId-attempt-attemptId-event",
    path: "/sequence/:sequenceId()/attempt/:attemptId()/event",
    meta: eventDRaidgcymTRceI8UIqQ2YacWiUCXYIDQYkeb974t6LIMeta || {},
    component: () => import("/home/runner/work/studio-web-app/studio-web-app/pages/sequence/[sequenceId]/attempt/[attemptId]/event.vue")
  },
  {
    name: "sequence-sequenceId-attempt-attemptId",
    path: "/sequence/:sequenceId()/attempt/:attemptId()",
    meta: indexNCW8DWhl_O_NIjHZVvB87X1WKer1PYxdebp92gopgA4Meta || {},
    component: () => import("/home/runner/work/studio-web-app/studio-web-app/pages/sequence/[sequenceId]/attempt/[attemptId]/index.vue")
  },
  {
    name: "organizationSlug-workspaceId-sequences",
    path: "/:organizationSlug()/:workspaceId()/sequences",
    component: () => import("/home/runner/work/studio-web-app/studio-web-app/pages/[organizationSlug]/[workspaceId]/sequences/index.vue")
  },
  {
    name: "organizationSlug-workspaceId-characters",
    path: "/:organizationSlug()/:workspaceId()/characters",
    component: () => import("/home/runner/work/studio-web-app/studio-web-app/pages/[organizationSlug]/[workspaceId]/characters/index.vue")
  },
  {
    name: "organizationSlug-workspaceId-sequences-create",
    path: "/:organizationSlug()/:workspaceId()/sequences/create",
    component: () => import("/home/runner/work/studio-web-app/studio-web-app/pages/[organizationSlug]/[workspaceId]/sequences/create.vue")
  },
  {
    name: "organizationSlug-workspaceId-assessments",
    path: "/:organizationSlug()/:workspaceId()/assessments",
    component: () => import("/home/runner/work/studio-web-app/studio-web-app/pages/[organizationSlug]/[workspaceId]/assessments/index.vue")
  },
  {
    name: "organizationSlug-workspaceId-characters-create",
    path: "/:organizationSlug()/:workspaceId()/characters/create",
    component: () => import("/home/runner/work/studio-web-app/studio-web-app/pages/[organizationSlug]/[workspaceId]/characters/create.vue")
  },
  {
    name: "organizationSlug-workspaceId-simulations",
    path: "/:organizationSlug()/:workspaceId()/simulations",
    component: () => import("/home/runner/work/studio-web-app/studio-web-app/pages/[organizationSlug]/[workspaceId]/simulations/index.vue")
  },
  {
    name: "organizationSlug-workspaceId-assessments-create",
    path: "/:organizationSlug()/:workspaceId()/assessments/create",
    component: () => import("/home/runner/work/studio-web-app/studio-web-app/pages/[organizationSlug]/[workspaceId]/assessments/create.vue")
  },
  {
    name: "organizationSlug-workspaceId-environments",
    path: "/:organizationSlug()/:workspaceId()/environments",
    component: () => import("/home/runner/work/studio-web-app/studio-web-app/pages/[organizationSlug]/[workspaceId]/environments/index.vue")
  },
  {
    name: "organizationSlug-workspaceId-simulations-create",
    path: "/:organizationSlug()/:workspaceId()/simulations/create",
    component: () => import("/home/runner/work/studio-web-app/studio-web-app/pages/[organizationSlug]/[workspaceId]/simulations/create.vue")
  },
  {
    name: "organizationSlug-workspaceId-environments-create",
    path: "/:organizationSlug()/:workspaceId()/environments/create",
    component: () => import("/home/runner/work/studio-web-app/studio-web-app/pages/[organizationSlug]/[workspaceId]/environments/create.vue")
  },
  {
    name: "organizationSlug-workspaceId-tests-testId",
    path: "/:organizationSlug()/:workspaceId()/tests/:testId()",
    component: () => import("/home/runner/work/studio-web-app/studio-web-app/pages/[organizationSlug]/[workspaceId]/tests/[testId]/index.vue")
  },
  {
    name: "organizationSlug-workspaceId-saq-questionId",
    path: "/:organizationSlug()/:workspaceId()/saq/:questionId()",
    component: () => import("/home/runner/work/studio-web-app/studio-web-app/pages/[organizationSlug]/[workspaceId]/saq/[questionId]/index.vue")
  },
  {
    name: "organizationSlug-workspaceId-characters-characterId",
    path: "/:organizationSlug()/:workspaceId()/characters/:characterId()",
    component: () => import("/home/runner/work/studio-web-app/studio-web-app/pages/[organizationSlug]/[workspaceId]/characters/[characterId].vue")
  },
  {
    name: "organizationSlug-workspaceId-feedback-testAttemptId",
    path: "/:organizationSlug()/:workspaceId()/feedback/:testAttemptId()",
    component: () => import("/home/runner/work/studio-web-app/studio-web-app/pages/[organizationSlug]/[workspaceId]/feedback/[testAttemptId].vue")
  },
  {
    name: "organizationSlug-workspaceId-environments-environmentId",
    path: "/:organizationSlug()/:workspaceId()/environments/:environmentId()",
    component: () => import("/home/runner/work/studio-web-app/studio-web-app/pages/[organizationSlug]/[workspaceId]/environments/[environmentId].vue")
  },
  {
    name: "organizationSlug-workspaceId-sequences-sequenceId",
    path: "/:organizationSlug()/:workspaceId()/sequences/:sequenceId()",
    component: () => import("/home/runner/work/studio-web-app/studio-web-app/pages/[organizationSlug]/[workspaceId]/sequences/[sequenceId]/index.vue")
  },
  {
    name: "organizationSlug-workspaceId-assessments-assessmentId",
    path: "/:organizationSlug()/:workspaceId()/assessments/:assessmentId()",
    component: () => import("/home/runner/work/studio-web-app/studio-web-app/pages/[organizationSlug]/[workspaceId]/assessments/[assessmentId]/index.vue")
  },
  {
    name: "organizationSlug-workspaceId-simulations-simulationId",
    path: "/:organizationSlug()/:workspaceId()/simulations/:simulationId()",
    component: () => import("/home/runner/work/studio-web-app/studio-web-app/pages/[organizationSlug]/[workspaceId]/simulations/[simulationId]/index.vue")
  },
  {
    name: "organizationSlug-workspaceId-tests-testId-submissions",
    path: "/:organizationSlug()/:workspaceId()/tests/:testId()/submissions",
    component: () => import("/home/runner/work/studio-web-app/studio-web-app/pages/[organizationSlug]/[workspaceId]/tests/[testId]/submissions/index.vue")
  },
  {
    name: "organizationSlug-workspaceId-saq-questionId-submissions",
    path: "/:organizationSlug()/:workspaceId()/saq/:questionId()/submissions",
    component: () => import("/home/runner/work/studio-web-app/studio-web-app/pages/[organizationSlug]/[workspaceId]/saq/[questionId]/submissions/index.vue")
  },
  {
    name: "organizationSlug-workspaceId-simulations-simulationId-preview",
    path: "/:organizationSlug()/:workspaceId()/simulations/:simulationId()/preview",
    meta: previewuz5uXkKNLkucZov0IcKF33XCPUmUUMRoWRw7EUT2ZP4Meta || {},
    component: () => import("/home/runner/work/studio-web-app/studio-web-app/pages/[organizationSlug]/[workspaceId]/simulations/[simulationId]/preview.vue")
  },
  {
    name: "organizationSlug-workspaceId-sequences-sequenceId-submissions",
    path: "/:organizationSlug()/:workspaceId()/sequences/:sequenceId()/submissions",
    component: () => import("/home/runner/work/studio-web-app/studio-web-app/pages/[organizationSlug]/[workspaceId]/sequences/[sequenceId]/submissions/index.vue")
  },
  {
    name: "organizationSlug-workspaceId-saq-questionId-submissions-submissionId",
    path: "/:organizationSlug()/:workspaceId()/saq/:questionId()/submissions/:submissionId()",
    component: () => import("/home/runner/work/studio-web-app/studio-web-app/pages/[organizationSlug]/[workspaceId]/saq/[questionId]/submissions/[submissionId].vue")
  },
  {
    name: "organizationSlug-workspaceId-assessments-assessmentId-submissions",
    path: "/:organizationSlug()/:workspaceId()/assessments/:assessmentId()/submissions",
    component: () => import("/home/runner/work/studio-web-app/studio-web-app/pages/[organizationSlug]/[workspaceId]/assessments/[assessmentId]/submissions/index.vue")
  },
  {
    name: "organizationSlug-workspaceId-simulations-simulationId-interactions",
    path: "/:organizationSlug()/:workspaceId()/simulations/:simulationId()/interactions",
    component: () => import("/home/runner/work/studio-web-app/studio-web-app/pages/[organizationSlug]/[workspaceId]/simulations/[simulationId]/interactions/index.vue")
  },
  {
    name: "organizationSlug-workspaceId-tests-testId-submissions-testSubmissionId",
    path: "/:organizationSlug()/:workspaceId()/tests/:testId()/submissions/:testSubmissionId()",
    component: () => import("/home/runner/work/studio-web-app/studio-web-app/pages/[organizationSlug]/[workspaceId]/tests/[testId]/submissions/[testSubmissionId].vue")
  },
  {
    name: "organizationSlug-workspaceId-sequences-sequenceId-submissions-submissionId",
    path: "/:organizationSlug()/:workspaceId()/sequences/:sequenceId()/submissions/:submissionId()",
    component: () => import("/home/runner/work/studio-web-app/studio-web-app/pages/[organizationSlug]/[workspaceId]/sequences/[sequenceId]/submissions/[submissionId].vue")
  },
  {
    name: "organizationSlug-workspaceId-simulations-simulationId-interactions-interactionId",
    path: "/:organizationSlug()/:workspaceId()/simulations/:simulationId()/interactions/:interactionId()",
    component: () => import("/home/runner/work/studio-web-app/studio-web-app/pages/[organizationSlug]/[workspaceId]/simulations/[simulationId]/interactions/[interactionId].vue")
  },
  {
    name: "organizationSlug-workspaceId-assessments-assessmentId-submissions-assessmentSubmissionId",
    path: "/:organizationSlug()/:workspaceId()/assessments/:assessmentId()/submissions/:assessmentSubmissionId()",
    component: () => import("/home/runner/work/studio-web-app/studio-web-app/pages/[organizationSlug]/[workspaceId]/assessments/[assessmentId]/submissions/[assessmentSubmissionId].vue")
  }
]